import React, { useEffect, useState, useRef } from "react";
import { Typography } from "@mhome/ui";
import BrightnessBar from "../common/brightness-bar";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { spacingToPx } from "../../lib/utils";

const BrightnessNumberDetail1Widget = ({
  widget,
  onValueUpdate,
  pattern,
  isEditing = false,
}) => {
  const [brightness, setBrightness] = useState(0);
  const [minMax, setMinMax] = useState({ min: 0, max: 100 });
  const sliderRef = React.useRef(null);
  const lastValueRef = useRef(null);

  useEffect(() => {
    if (widget) {
      const initialValue = Number(widget.value);
      const validValue = isNaN(initialValue) ? 0 : initialValue;
      setMinMax({
        min: widget.min ?? 0,
        max: widget.max ?? 100,
      });
      setBrightness(validValue);
      lastValueRef.current = validValue;
    }
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    if (data === lastValueRef.current) return;
    const updatedWidget = {
      ...widget,
      value: data,
    };
    lastValueRef.current = data;
    onValueUpdate(updatedWidget);
  };

  const handleBrightnessChange = (event, newValue) => {
    event.stopPropagation();
    const adjustedValue = Math.min(Math.max(newValue, minMax.min), minMax.max);
    setBrightness(adjustedValue);
  };

  const disabled = pattern && pattern.endsWith("_R");
  const showWarning = pattern && pattern.endsWith("_W");

  return (
    <div className="w-full flex flex-col" style={{ gap: spacingToPx(2) }}>
      {/* Brightness Controls Section */}
      <div
        className="flex flex-col"
        style={{
          borderRadius: spacingToPx(4),
          padding: spacingToPx(1.5),
          backgroundColor: "hsl(var(--card))",
        }}
      >
        <Typography
          variant="body2"
          className="font-bold flex items-center"
          style={{
            marginBottom: spacingToPx(1.5),
            gap: spacingToPx(0.5),
          }}
        >
          {widget?.description ? widget.description : "Brightness"}
          {showWarning && (
            <SyncProblemIcon
              className="text-inherit"
              style={{ color: "hsl(var(--warning))" }}
            />
          )}
        </Typography>

        <div className="h-9 w-full relative">
          <BrightnessBar
            value={brightness}
            onChange={handleBrightnessChange}
            onValueUpdate={handleValueUpdate}
            disabled={disabled || isEditing}
            min={minMax.min}
            max={minMax.max}
            sliderRef={sliderRef}
            showLevel={true}
            showText="Brightness"
          />
        </div>
      </div>
    </div>
  );
};

export default BrightnessNumberDetail1Widget;
